import React from "react";
import Panel from "../../../common/components/Panel";
import { PanelModel } from "../../Models/PanelModel";
import ComponentFactory from "../ComponentFactory";
import IComponentProps from "../IComponentProps";
import getComponentLayout from "../Table/getComponentLayout";
import PanelAction from "./PanelAction";

const PanelComponent: React.FC<IComponentProps<PanelModel>> = ({ component, context }) => {
  const componentLayoutSx = getComponentLayout(component);
  const headerActionSize = component.Compact ? "small" : "medium";

  return (
    <Panel
      headerLabel={component.HeaderLabel}
      headerIconName={component.HeaderIconName}
      headerActions={component.HeaderActions ? <PanelAction actions={component.HeaderActions} size={headerActionSize} context={context} /> : undefined}
      compact={component.Compact}
      sx={componentLayoutSx}
    >
      {component.Children.map((child) => (
        <ComponentFactory key={child.Id} parent={component} component={child} context={context} />
      ))}
    </Panel>
  );
};

export default PanelComponent;
